// extracted by mini-css-extract-plugin
export default {"offsetFilter":"style-module--offset-filter--94846","agencyOverviewTitle":"style-module--agency-overview-title--57e1d"};